<p-card>
  <header class="login-brand">
    @if ($branding.logoMenu(); as logo) {
      <img class="login-brand__logo" [src]="logo" [alt]="$branding.displayName()" />
    }
    <h1 class="login-heading">Oficina Virtual</h1>
    <p class="login-area">Área propietarios</p>
  </header>
  @if (buildInfo.showEnvironmentBadge()) {
    <p-message severity="info" styleClass="app-environment-meta mb-3 w-100">
      <span class="app-environment-meta__badge">{{ buildInfo.environmentLabel() }}</span>
      <span class="app-environment-meta__version">{{ buildInfo.versionLabel() }}</span>
    </p-message>
  }
  <form [formGroup]="form">
    <p-floatlabel variant="in">
      <p-iconfield>
        <p-inputicon class="pi pi-user" />
        <input
          pInputText
          id="username"
          class="w-100"
          formControlName="username"
          autocomplete="username"
        />
      </p-iconfield>
      <label for="username">Usuario o email</label>
    </p-floatlabel>

    <p-floatlabel class="my-3 password-field" variant="in">
      <p-iconfield>
        <p-inputicon class="pi pi-lock" />
        <input
          pInputText
          [type]="showPassword ? 'text' : 'password'"
          id="password"
          class="w-100"
          formControlName="password"
          autocomplete="current-password"
        />
        <p-inputicon>
          <p-button
            [icon]="showPassword ? 'pi pi-eye-slash' : 'pi pi-eye'"
            [text]="true"
            [rounded]="true"
            severity="secondary"
            type="button"
            [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'"
            (onClick)="showPassword = !showPassword"
          />
        </p-inputicon>
      </p-iconfield>
      <label for="password">Contraseña</label>
    </p-floatlabel>

    <div class="d-flex">
      <a class="pointer ms-auto mb-3" (click)="navigateTo('RECOVERY_PASSWORD')"
        >¿Has olvidado tu contraseña?</a
      >
    </div>

    <p-button
      type="submit"
      [label]="!isLoading ? 'Acceder' : 'Iniciando sesión...'"
      (onClick)="submit()"
      class="w-100"
      [style]="{ width: '100%' }"
      [disabled]="isLoading"
    />
    @if (!!loginError) {
      <p-message styleClass="mt-3" severity="error">{{ loginError }}</p-message>
    }

    <a class="demo-access" routerLink="/login-demostracion">Acceso de demostración</a>

    <hr />

    <h4>¿Aún no estás registrado?</h4>

    <p-button
      severity="secondary"
      outlined="true"
      label="Regístrate"
      styleClass="login-register"
      (onClick)="navigateTo('REGISTER')"
      class="w-100"
      [style]="{ width: '100%' }"
    />

    @if ($branding.isGGM()) {
      <a class="previous-office" data-testid="ov-previous-office" [href]="previousOfficeUrl">
        Versión anterior
      </a>
      <nav class="other-areas" aria-label="Otras áreas">
        <a data-testid="ov-property-managers" [href]="propertyManagersOfficeUrl">
          Área administradores de fincas
        </a>
        <span class="other-areas__sep" aria-hidden="true">|</span>
        <a data-testid="ov-fixed-networks" [href]="fixedNetworksOfficeUrl">Área Redes Fijas</a>
      </nav>
    }
  </form>
</p-card>
